/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { LiveblocksControllerResolveMentionSuggestionsMutationResponse, LiveblocksControllerResolveMentionSuggestions401, LiveblocksControllerResolveMentionSuggestions403 } from "../../models/liveblocksController/LiveblocksControllerResolveMentionSuggestions";

function getLiveblocksControllerResolveMentionSuggestionsUrl() {
  const res = { method: 'POST', url: `/api/v1/liveblocks/resolve-mention-suggestions` as const }  
  return res
}

/**
 * @summary Search users for @mention suggestions
 * {@link /api/v1/liveblocks/resolve-mention-suggestions}
 */
export async function liveblocksControllerResolveMentionSuggestions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<LiveblocksControllerResolveMentionSuggestionsMutationResponse, ResponseErrorConfig<LiveblocksControllerResolveMentionSuggestions401 | LiveblocksControllerResolveMentionSuggestions403>, unknown>({ method : "POST", url : getLiveblocksControllerResolveMentionSuggestionsUrl().url.toString(), ... requestConfig })  
  return res.data
}